import { PaginatorResult } from '~/api';
import { buildModule, createFiltersModule, createPaginationModule, defineSingleFilter } from '../utils';

export default buildModule()
	.withSubmodules({
		filters: createFiltersModule({
			filters: {
				searchTerm: defineSingleFilter('tagCategorySearchTerm', String),
			},
		}),
	})
	.withSubmodules({
		pagination: createPaginationModule({
			itemCountGetter: 'tagCategory/totalCount',
		}),
	})
	.withState({
		paginator: null as PaginatorResult | null,
	})
	.withGetters({
		totalCount: state => state.paginator?.totalCount ?? 0,
	})
	.withMutations({
		SET_PAGINATOR (state, paginator: PaginatorResult) {
			state.paginator = paginator;
		},
	});
